import { branch } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";
import _ from "lodash";
import React from "react";
import autoBind from "react-autobind";
import { Button } from "react-bootstrap";
// import { BigPlayButton, ControlBar, Player } from "video-react";
import { showVideoPreview, /*duckBackgroundAudio, unduckBackgroundAudio,*/ handleAudioPropertyStateChange } from "../../actions/playerActions";
import SyntheticVoiceApi from "../../speech/SyntheticVoiceApi";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import { generateUUID } from "../../utils/utils";


// import "../node_modules/video-react/dist/video-react.css";
// import "./Video.css";


/*
	Video player component for items
*/
class PlayerItemVideo extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);

		this.state = {
			playsInline: true,
			key:generateUUID()
		};
	}

	componentWillReceiveProps(nextProps) {
		if (!nextProps.hasOwnProperty("showMode") || !nextProps.showMode) {
			if (this.props.selected === false && nextProps.selected === true) {
				this.handlePlayVideo();
			} else if (this.props.selected === true && nextProps.selected === false) {
				this.handleStopVideo();
			}	
		}
	}

	
	async handlePlayVideo() {
		const { playerMuted, itemGuid } = this.props;
		// const self=this;
		let video = _.get(this.props.videoRef, "current");
		console.log("Handle play video", this.props.videoRef, playerMuted);
		if (video) {
			// setTimeout(() => {
			setTimeout(() => {
				// video.play();
				// setTimeout(() => {
					if (!playerMuted) {
						// video.removeAttribute("muted");
						video.muted = false;
						// handleReviveVideo(`video-${this.state.key}`);
						// video.pause();
						video.play();
						handleAudioPropertyStateChange(itemGuid, "video", true);
						// video.muted = false;
					} else {
						video.pause();
						video.play();
						handleAudioPropertyStateChange(itemGuid, "video", true, {muted:true});
					}
				// }, 3000);
			
				// video.loop = self.props.loop;
				// video.currentTime = 0;
			},300);
			// try {

			// 	handleReviveVideo(`video-${this.state.key}`);
			// } catch (e) {
			// 	console.error(e);
			// }
			
			
					// 			if (video.paused) {
					// 	// Try again!
					// 	// alert("TRY AGAIN - VIDEO AUTO PLAY");
					// 	video.play();
					// }
				// setTimeout(() => {
				// 	if (video.paused) {
				// 		// Try again!
				// 		// alert("TRY AGAIN - VIDEO AUTO PLAY");
				// 		try {
				// 			video.play();
				// 		} catch (e) { }
				// 	}
				// },1000);
			// }, 250);
		}
	}

	handleStopVideo() {
		let video = _.get(this.props.videoRef, "current");
		if (video) {
			video.pause();
			video.removeAttribute("src");
			video.load();
			this.setState({
				key:generateUUID()
			});
			let { itemGuid, playerMuted } = this.props;
			handleAudioPropertyStateChange(itemGuid, "video", false, { muted: playerMuted });
		}
	}

	componentDidMount() {
		// if (isIphone()) {
		// 	//listen for native player close
		// 	this.props.videoRef.current.addEventListener("webkitendfullscreen", this.handleCloseIosNativeFullscreen);
		// 	this.props.videoRef.current.addEventListener("click", this.handleVideoOnClick);
		// }
		if (this.props.autoPlay && this.props.selected) {
			this.handlePlayVideo();
		}
	}

	componentWillUnmount() { 
		// if (isIphone()) {			
		// 	this.props.videoRef.current.removeEventListener("webkitendfullscreen", this.handleCloseIosNativeFullscreen);
		// 	this.props.videoRef.current.removeEventListener("click", this.handleVideoOnClick);
		// }
	}

	// handleVideoOnClick() {
	// 	this.handlePlayFullscreen();
	// }

	handleCloseIosNativeFullscreen() {
		this.setState({
			playsInline: true
		});
}	

	handlePlayFullscreen(video) {
		SyntheticVoiceApi.stop();

		showVideoPreview(this.context.tree,video);

		// if (ref && ref.current) {
			
		// 	ref.current.pause();
		// 	ref.current.seek(0);			

		// 	if (isIphone()) {
		// 		this.setState({
		// 			playsInline: false
		// 		});

		// 		setTimeout(() => {
		// 			ref.current.muted = false;
		// 			ref.current.play();
		// 		});				
		// 	} else {
		// 		ref.current.toggleFullscreen();
		// 		ref.current.muted = false;
		// 		ref.current.play();				
				
		// 	}			
		// }
	}
	


	render() {
		let { videoRef, url, playerMuted, /*autoPlay,*/ loop,itemGuid, videoOptions={}} = this.props;	
		// const { videoPlayEngaged } = this.state;

		// if (autoPlay && !videoPlayEngaged) {
		// 	this.handlePlayVideo();
		// }

		const showMode = (this.props.hasOwnProperty("showMode") && this.props.showMode) ? true : false; 

		// let controls = /*(!isIphone()) ?
		// 	<ControlBar disableDefaultControls={true}>
		// 		<PlayToggle />
		// 		<VolumeMenuButton />
		// 		<CurrentTimeDisplay />
		// 		<TimeDivider />
		// 		<DurationDisplay />
		// 		<ProgressControl />
		// 	</ControlBar> :*/ <ControlBar disableCompletely={true} />;

		let addtlProps = {};
		if (this.props.selected || this.props.showMode) {
			addtlProps.src=url;
		}

		// Setting properties to just the attribute name (instead of empty): https://stackoverflow.com/questions/14111917/html5-video-muted-but-still-playing
		if (loop) {
			addtlProps.loop = "loop";
		}

		//For autoPlay to work needs to be muted, can then unmute later:  https://medium.com/code-divoire/autoplaying-inline-videos-on-iphone-ios-10-using-angular-d4e2eaba2164
			// addtlProps.muted = "muted";

		// if (autoPlay) {
		// 	addtlProps.autoplay = "autoplay";
		// }

		// console.log("###### playerMute: " + playerMuted);
		// console.log("###### playerLoop: " + loop);

		// if (playerMuted) {
		// 	addtlProps.muted = playerMuted;
		// }
		// if (loop) {
		// 	addtlProps.loop = loop;
		// }

		let component = <div className={showMode?"my-video-react-video-show-mode":"my-video-react-video"} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent:"conter", width: "100%", height: showMode?"90%":"40vh", position:"relative" }}>
			<video
				// autoplay
				muted
				id={`video-${this.state.key}`}
				key={this.state.key}
				width="100%"
				height="100%"
				playsInline={true}
				// muted={muted}
				aspectRatio={this.props.aspectRatio}
				// autoPlay={this.props.autoPlay}
				// muted={showMode ? false : playerMuted}
				ref={videoRef}
				fluid={false}
				// onLoadStart={() => {}}
				onError = {()=>{
					const { listIndex, sectionIndex, itemIndex } = this.props;

					const pos = listIndex + "," + sectionIndex + "," + itemIndex;
		
					global.loadedVideosHash[pos] = "error";
					handleAudioPropertyStateChange(itemGuid, "video", false, { muted: playerMuted });
				}}
				onLoadedMetadata={()=>{
					const { listIndex, sectionIndex, itemIndex } = this.props;

					const pos = listIndex + "," + sectionIndex + "," + itemIndex;

					global.loadedVideosHash[pos] = "loaded";
				}}
				onEnded={() =>  {
					let video = _.get(this.props.videoRef, "current");
					handleAudioPropertyStateChange(itemGuid, "video", false, { muted: playerMuted});

					if (videoOptions && !videoOptions.resetAfterEnd) {
							video.pause();
							return;
					}
					video.currentTime = 0;				
				}}
				// loop={loop}
				{...addtlProps}
				>
				
				{/* <BigPlayButton position="center" /> */}
				{/* {controls} */}
				{/* <track
									kind="captions"
									src="https://assets-ambifi-com.s3.amazonaws.com/public/projects/helmet-ventilation/subtitles/venturi-setup/captions-en.vtt"
									srcLang="en"
									label="English"
									default
								/> */}

			</video>
			{/* !webMode && <Button style={{ marginTop: "10px", marginBottom: "10px" }} onClick={() => { handleOpenInNewTab(url); }}><FontAwesomeIcon icon="external-link" /> View In New Tab</Button> */}
			{((!this.props.hasOwnProperty("showFullscreenToggle") || this.props.showFullscreenToggle) && (_.isString(url) && url !== "")) &&
				<div style={{ position: "absolute", right: 0, bottom: 0 }}>
					<Button style={{ border: 0, borderRadius:10, backgroundColor: "rgba(0,0,0,.7)", color: "white" }} onClick={(e) => { e.stopPropagation(); this.handlePlayFullscreen(url); }}><FontAwesomeIcon icon="expand-wide" /></Button>
				</div>
			}
		</div>;

		return component;
	}

}


PlayerItemVideo.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	content: ["content"]
}, PlayerItemVideo);